import { render, staticRenderFns } from "./VideoTypeSelector.vue?vue&type=template&id=afec7334&scoped=true"
import script from "./VideoTypeSelector.vue?vue&type=script&lang=js"
export * from "./VideoTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./VideoTypeSelector.vue?vue&type=style&index=0&id=afec7334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afec7334",
  null
  
)

export default component.exports